import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "./controlInput";

export interface ControlFileProps extends ControlTemplateProps {
    
}

export const ControlFile: React.FC<ControlFileProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="file" {...ComponentProps(props)} style={{ ...styles.file ?? styles.text ?? styles.input, ...props.style }} />        
    );
};